import React, { useEffect, useState } from "react";
import API from "./axiosInstance";
import "./AdminPanel.css";

function AdminCoupons() {
  const [coupons, setCoupons] = useState([]);
  const [formData, setFormData] = useState({
    code: "",
    discountType: "PERCENT",
    discountValue: "",
    minOrder: "",
    maxDiscount: "",
    expiryDate: "",
    usageLimit: "",
  });

  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const fetchCoupons = async () => {
    try {
      const res = await API.get("/coupons");
      setCoupons(res.data);
    } catch (err) {
      console.error(err.response?.data || err.message);
    }
  };

  useEffect(() => {
    fetchCoupons();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...formData,
        discountValue: Number(formData.discountValue),
        minOrder: Number(formData.minOrder),
        maxDiscount: Number(formData.maxDiscount),
        usageLimit: Number(formData.usageLimit),
      };
      setLoading(true);
      await API.post("/coupons/create", payload);
      alert("✅ Coupon created");
      setFormData({
        code: "",
        discountType: "PERCENT",
        discountValue: "",
        minOrder: "",
        maxDiscount: "",
        expiryDate: "",
        usageLimit: "",
      });
      fetchCoupons();
    } catch (err) {
      alert(err.response?.data?.message || "Failed to create coupon");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this coupon?")) return;
    try {
      await API.delete(`/coupons/${id}`);
      fetchCoupons();
    } catch (err) {
      alert("Delete failed");
    }
  };

  const filteredCoupons = coupons.filter(
    (c) => c.code.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="admin-container">
      <div className="main-content">
        <h2>🎟 Coupons</h2>
        <div className="card form-card">
          <form onSubmit={handleSubmit} style={{ display: "grid", gap: 10 }}>
            <input
              placeholder="Coupon Code"
              value={formData.code}
              onChange={(e) =>
                setFormData({ ...formData, code: e.target.value.toUpperCase() })
              }
              required
            />
            <select
              value={formData.discountType}
              onChange={(e) =>
                setFormData({ ...formData, discountType: e.target.value })
              }
            >
              <option value="PERCENT">Percentage (%)</option>
              <option value="FLAT">Flat ₹</option>
            </select>
            <input
              type="number"
              placeholder="Discount Value"
              value={formData.discountValue}
              onChange={(e) =>
                setFormData({ ...formData, discountValue: e.target.value })
              }
              required
            />
            <input
              type="number"
              placeholder="Minimum Order ₹"
              value={formData.minOrder}
              onChange={(e) =>
                setFormData({ ...formData, minOrder: e.target.value })
              }
              required
            />
            <input
              type="number"
              placeholder="Max Discount ₹"
              value={formData.maxDiscount}
              onChange={(e) =>
                setFormData({ ...formData, maxDiscount: e.target.value })
              }
            />
            <input
              type="date"
              value={formData.expiryDate}
              onChange={(e) =>
                setFormData({ ...formData, expiryDate: e.target.value })
              }
              required
            />
            <input
              type="number"
              placeholder="Usage Limit"
              value={formData.usageLimit}
              onChange={(e) =>
                setFormData({ ...formData, usageLimit: e.target.value })
              }
            />
            <button type="submit" disabled={loading}>
              {loading ? "⏳ Creating..." : "Create Coupon"}
            </button>
          </form>
        </div>

        <input
          placeholder="Search Coupon Code..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ margin: "15px 0", padding: 8 }}
        />

        <div className="product-grid">
          {filteredCoupons.map((c) => (
            <div key={c.id} className="card product-card">
              <h3>{c.code}</h3>
              <p>Type: {c.discountType}</p>
              <p>
                Value: {c.discountValue} {c.discountType === "PERCENT" ? "%" : "₹"}
              </p>
              <p>Min Order: ₹{c.minOrder}</p>
              <p>Max Discount: ₹{c.maxDiscount || "-"}</p>
              <p>Expiry: {new Date(c.expiryDate).toLocaleDateString()}</p>
              <p>Status: {c.isActive ? "Active" : "Inactive"}</p>
              <button className="btn-delete" onClick={() => handleDelete(c.id)}>
                Delete
              </button>
            </div>
          ))}
          {filteredCoupons.length === 0 && <p>No coupons found.</p>}
        </div>
      </div>
    </div>
  );
}

export default AdminCoupons;
